import { ArrowLeftIcon, ArrowRightIcon, InfoIcon } from 'lucide-react';

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { Item, ItemContent, ItemDescription, ItemMedia, ItemTitle } from '@/components/ui/item';
import { getProviderDisplayName } from 'src/utils/getProviderDisplayName';

import { useIntegration } from '../model';

const SetupAlertDialog = () => {
  const { isSetupAlertOpen, provider, type, activateCustomIntegration, activateOauthIntegration, chooseProvider } =
    useIntegration();

  const onContinue = () => {
    if (type === 'custom') return activateCustomIntegration(provider);
    if (type === 'oauth') return activateOauthIntegration(provider);
    return null;
  };

  return (
    <AlertDialog open={isSetupAlertOpen}>
      <AlertDialogContent>
        <AlertDialogHeader className="gap-1.5 text-left">
          <AlertDialogTitle className="leading-4.5">Set up your integration</AlertDialogTitle>
          <AlertDialogDescription>Connecting to {getProviderDisplayName(provider as string)}</AlertDialogDescription>
        </AlertDialogHeader>
        <Item className="p-0 pt-2">
          <ItemMedia variant="icon">
            <InfoIcon />
          </ItemMedia>
          <ItemContent>
            <ItemTitle>Check your permissions before continuing</ItemTitle>
            <ItemDescription className="line-clamp-none text-wrap">
              You&apos;ll need account-level access and permission to share at the asset level. If either is missing,
              you won&apos;t be able to deposit assets connected to this integration.
            </ItemDescription>
          </ItemContent>
        </Item>
        <AlertDialogFooter>
          <Button variant="outline" size="sm" className="sm:flex-1" onClick={chooseProvider}>
            <ArrowLeftIcon /> Back to integration library
          </Button>
          <Button size="sm" className="sm:flex-1" onClick={onContinue}>
            Continue <ArrowRightIcon />
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default SetupAlertDialog;
